module.exports = __webpack_public_path__ + "static/media/financialInstitution.1724c8af.svg";